<template>
    <div>
      <trademark-bulletin-check-list></trademark-bulletin-check-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  